import { useEffect } from "react"
import $ from '../../../libs/owl-global';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

export const useHome = () => {

    function shuffle(array) {
        let currentIndex = array.length, randomIndex;

        while (currentIndex !== 0) {
            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex--;

            // Intercambio
            [array[currentIndex], array[randomIndex]] = [
                array[randomIndex], array[currentIndex]];
        }

        return array;
    }

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, []);


    useEffect(() => {
        $(window).on('scroll', function () {
            if ($(window).scrollTop() > 10) {
                $('.navbar').addClass('active');
            } else {
                $('.navbar').removeClass('active');
            }
        });

        $('.main-slider').owlCarousel({
            loop: true,
            autoplay: true, 
            autoplayTimeout: 8000, 
            autoplayHoverPause: true,
            smartSpeed: 1000,
            animateOut: 'fadeOut',
            animateIn: 'fadeIn',
            dots: false,
            nav: true,
            navText: [
                "<img src='assets/img/slider/rightarrow.png' />",
                "<img src='assets/img/slider/leftarrow.png' />"
            ],
            responsive: {
                0: { items: 1 },
                600: { items: 1 },
                1000: { items: 1 }
            }
        });
    })

    return {
        functions: {
            shuffle
        }
    }
}